import { Col, Row, Spin } from "antd";
import { Power3, TweenMax } from "gsap";
import React, { Suspense, lazy, useEffect, useRef } from "react";
import { AnimationTime, SKILLS, TechSkills } from "../App.constant";
import Victor from "../assets/images/VictorFace.svg";
import carrotsuite from "../assets/images/carrotsuite.svg";
import fintrak from "../assets/images/fintrak.svg";
import hiit from "../assets/images/hiit.svg";
import mumspring from "../assets/images/mumspring.svg";
import stateWrapper from "../containers/provider";
import { useResponsive } from "../hooks/responsive";
import { useLocation } from "react-router";
const Projects = lazy(() => import("./Projects"));

const About = (props) => {
  const location = useLocation();

  const [
    isTabletOrMobileDevice,
    isTabletOrMobile,
    isBigScreen,
    isDesktopOrLaptop,
    isPortrait,
    isRetina,
    isTablet,
  ] = useResponsive();
  const logoRef = useRef(null);
  const textRef = useRef(null);
  const heroRef = useRef(null);

  const onMouseEnter = (e) => {};
  const onMouseLeave = (e) => {};

  useEffect(() => {
    TweenMax.to(logoRef.current, AnimationTime, {
      opacity: 1,
      y: -20,
      ease: Power3.easeInOut,
    }).play();

    TweenMax.to(textRef.current, AnimationTime, {
      opacity: 1,
      y: -20,
      ease: Power3.easeInOut,
      delay: 0.2,
    }).play();

    TweenMax.to(heroRef.current, AnimationTime, {
      opacity: 1,
      y: -20,
      ease: Power3.easeInOut,
      delay: 0.2,
    }).play();
  }, []);

  useEffect(() => {
    if (window) {
      props?.masterStore?.setSelectedBar(location?.pathname);
    }
  }, [location?.pathname]);

  return (
    <>
      <div style={{ width: "100%", height: "100%", marginTop: 100 }}>
        <div style={{ width: "100%" }}>
          <center>
            {isTabletOrMobile ? (
              <Row>
                <Col span={24}>
                  <img
                    ref={logoRef}
                    className="hover"
                    src={Victor}
                    style={{
                      width: isTabletOrMobileDevice ? 200 : 300,
                      height: isTabletOrMobileDevice ? 200 : 300,
                      opacity: 0,
                    }}
                  />
                </Col>
                <Col ref={textRef} style={{ opacity: 0 }} span={24}>
                  <span
                    style={{
                      color: "#FFFFFF",
                      fontSize: 14,
                      fontWeight: "lighter",
                      fontFamily: "Baloo 2, cursive",
                    }}
                  >
                    Hi, I am &nbsp;
                  </span>
                  <span
                    style={{
                      color: "#FFFFFF",
                      fontSize: 20,
                      fontWeight: "bold",
                      fontFamily: "Permanent Marker, cursive",
                    }}
                  >
                    Victor Umesiobi
                  </span>
                  <div>
                    <span
                      style={{
                        color: "#FFFFFF",
                        fontSize: 14,
                        fontWeight: "lighter",
                        fontFamily: "Baloo 2, cursive",
                      }}
                    >
                      and I am a &nbsp;
                    </span>
                    <span
                      style={{
                        color: "#FFFFFF",
                        fontSize: 20,
                        fontWeight: "bold",
                        fontFamily: "Permanent Marker, cursive",
                      }}
                    >
                      Fullstack Developer
                    </span>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col span={4}>
                  <img
                    ref={logoRef}
                    src={Victor}
                    style={{
                      width: isTabletOrMobileDevice ? 200 : 300,
                      height: isTabletOrMobileDevice ? 200 : 300,
                      position: "relative",
                      top: isTabletOrMobileDevice ? 0 : -100,
                      left: isTabletOrMobile ? 100 : 340,
                      opacity: 0,
                    }}
                  />
                </Col>
                <Col
                  ref={textRef}
                  span={20}
                  style={{ paddingLeft: "10%", opacity: 0 }}
                >
                  <span
                    style={{
                      color: "#FFFFFF",
                      fontSize: 14,
                      fontWeight: "lighter",
                      fontFamily: "Baloo 2, cursive",
                    }}
                  >
                    Hi, I am &nbsp;
                  </span>
                  <span
                    style={{
                      color: "#FFFFFF",
                      fontSize: 30,
                      fontWeight: "bold",
                      fontFamily: "Permanent Marker, cursive",
                    }}
                  >
                    Victor Umesiobi
                  </span>
                  <div>
                    <span
                      style={{
                        color: "#FFFFFF",
                        fontSize: 14,
                        fontWeight: "lighter",
                        fontFamily: "Baloo 2, cursive",
                      }}
                    >
                      and I am a &nbsp;
                    </span>
                    <span
                      style={{
                        color: "#FFFFFF",
                        fontSize: 30,
                        fontWeight: "bold",
                        fontFamily: "Permanent Marker, cursive",
                      }}
                    >
                      Fullstack Developer
                    </span>
                  </div>
                </Col>
              </Row>
            )}
          </center>
          <center
            ref={heroRef}
            style={{
              opacity: 0,
              position: "relative",
              top: isTabletOrMobile ? 0 : -90,
            }}
          >
            <div
              style={{
                width: isTabletOrMobileDevice ? "90%" : "70%",
                padding: 10,
                borderRadius: 20,
                marginTop: isTabletOrMobileDevice ? 20 : 10,
                marginBottom: 10,
                height: isTabletOrMobileDevice ? 250 : 240,
              }}
              className="glass-dark"
            >
              <Row>
                <Col span={24}>
                  <Row>
                    <Col span={20}></Col>
                    <Col span={4}>
                      <div style={{ width: "100%", marginLeft: "25%" }}>
                        <div
                          className="orange-dot"
                          style={{ position: "relative", right: 0 }}
                        ></div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <div
                    style={{
                      color: "#FFFFFF",
                      fontFamily: "Baloo 2, cursive",
                      fontWeight: "300",
                      paddingTop: isTabletOrMobileDevice ? 0 : 20,
                    }}
                  >
                    With a strong foundation built over 7 years in software
                    development, I have consistently delivered outstanding
                    results across a wide spectrum of projects. My extensive
                    experience includes collaborating effectively with
                    cross-functional teams, utilizing a deep knowledge of
                    diverse technologies to create exceptional web, mobile, and
                    desktop applications. My unwavering commitment to
                    self-improvement fuels my constant learning and
                    adaptability, allowing me to approach each project with a
                    unique problem-solving perspective. I am dedicated to
                    maintaining a track record of excellence. Thank you for
                    considering my profile.
                  </div>
                </Col>
              </Row>
            </div>
          </center>

          <center>
            <div
              style={{
                color: "#FFFFFF",
                padding: 10,
                marginTop: isTabletOrMobileDevice ? 20 : 10,
                textAlign: "center",
                fontFamily: "Permanent Marker, cursive",
              }}
            >
              Companies I have worked with
            </div>
            <div
              style={{
                width: isTabletOrMobileDevice ? "90%" : "70%",
                padding: 10,
                borderRadius: 20,
                marginTop: isTabletOrMobileDevice ? 20 : 10,
                marginBottom: 10,
              }}
              className="glass-dark"
            >
              <Row>
                <Col span={12}>
                  <a
                    target="_blank"
                    referrerPolicy="no-referrer"
                    href="https://www.fintraksoftware.com/"
                  >
                    <img
                      src={fintrak}
                      style={{ width: 150, height: 150 }}
                      className="hover"
                    />
                  </a>
                </Col>
                <Col span={12}>
                  <a
                    target="_blank"
                    referrerPolicy="no-referrer"
                    href="https://www.mumspring.com/"
                  >
                    <img
                      src={mumspring}
                      style={{ width: 150, height: 150 }}
                      className="hover"
                    />
                  </a>
                </Col>
                <Col span={12}>
                  <a
                    target="_blank"
                    referrerPolicy="no-referrer"
                    href="https://carrotsuite.com.ng/"
                  >
                    <img
                      src={carrotsuite}
                      style={{ width: 150, height: 150 }}
                      className="hover"
                    />
                  </a>
                </Col>
                <Col span={12}>
                  <a
                    target="_blank"
                    referrerPolicy="no-referrer"
                    href="https://www.hiitplc.com/"
                  >
                    <img
                      src={hiit}
                      style={{ width: 150, height: 150 }}
                      className="hover"
                    />
                  </a>
                </Col>
              </Row>
            </div>
          </center>

          <center>
            <div
              style={{
                color: "#FFFFFF",
                padding: 10,
                marginTop: isTabletOrMobileDevice ? 20 : 10,
                textAlign: "center",
                fontFamily: "Permanent Marker, cursive",
              }}
            >
              My Specialities
            </div>
            <div
              style={{
                width: isTabletOrMobileDevice ? "90%" : "70%",
                overflowWrap: "break-word",
                padding: 10,
                borderRadius: 20,
                marginTop: isTabletOrMobileDevice ? 20 : 10,
                marginBottom: 10,
              }}
            >
              {SKILLS.map((i) => {
                return (
                  <div style={{ display: "inline-block", marginTop: 20 }}>
                    <span
                      className="glass-light"
                      style={{
                        whiteSpace: "pre-wrap",
                        fontWeight: "200",
                        color: "#FFFFFF",
                        fontFamily: "Baloo 2, cursive",
                        padding: 10,
                      }}
                    >
                      {i}
                    </span>
                  </div>
                );
              })}
            </div>
          </center>

          <center>
            <div
              style={{
                color: "#FFFFFF",
                padding: 10,
                marginTop: isTabletOrMobileDevice ? 20 : 10,
                textAlign: "center",
                fontFamily: "Permanent Marker, cursive",
              }}
            >
              Technologies I use
            </div>
            <div
              style={{
                width: isTabletOrMobileDevice ? "90%" : "70%",
                padding: 10,
                borderRadius: 20,
                marginTop: isTabletOrMobileDevice ? 20 : 10,
                marginBottom: 10,
              }}
            >
              {TechSkills.map((i) => {
                return (
                  <div style={{ display: "inline-block", marginTop: 20 }}>
                    <span
                      className="glass-light"
                      style={{
                        whiteSpace: "pre-wrap",
                        fontWeight: "200",
                        color: "#FFFFFF",
                        fontFamily: "Baloo 2, cursive",
                        padding: 10,
                      }}
                    >
                      {i}
                    </span>
                  </div>
                );
              })}
            </div>
          </center>

          <div id="project" style={{ marginTop: 40 }}>
            {isTabletOrMobileDevice ? (
              <Col span={24} style={{ padding: 20 }}>
                <div
                  style={{
                    fontFamily: "Permanent Marker, cursive",
                    color: "#FFF",
                    fontSize: 18,
                  }}
                >
                  Projects
                </div>
                <Suspense
                  fallback={
                    <center>
                      <div className="spin">
                        <Spin />
                      </div>
                    </center>
                  }
                >
                  <Projects
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                  />
                </Suspense>
              </Col>
            ) : (
              <Col
                span={24}
                style={{ paddingLeft: "15%", paddingRight: "15%" }}
              >
                <div
                  style={{
                    fontFamily: "Permanent Marker, cursive",
                    color: "#FFF",
                    fontSize: 18,
                  }}
                >
                  Projects
                </div>
                <Suspense
                  fallback={
                    <center>
                      <div className="spin">
                        <Spin />
                      </div>
                    </center>
                  }
                >
                  <Projects
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                  />
                </Suspense>
              </Col>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default stateWrapper(About);
